// @flow

import React, { lazy } from 'react'
import { PrivateRoute } from 'src/common/components'
const UsersList = lazy(() => import('src/modules/users/usersList'))

export default [
  <PrivateRoute exact={true} path="/my-leagues/:leagueId/members" component={UsersList} key="members" />,
]
